import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
// import EditUserForm from 'components/Admin/User/EditUserForm';
import ProfileForm from 'components/Profile/Profile';
import actions from 'actions';
import constants from 'constants';
import validator from 'services/validator';
import inputFormatter from 'services/userInputFormatter';

const {
  ERROR_TYPE_USER_UPDATE_ERROR,
  ADMIN_UPDATE_USER_SAGA
} = constants;

const {
  loadEditUser,
  adminUpdateUserSaga,
  addValidateError,
  cleanErrors,
} = actions;

class EditUser extends Component {
  static propTypes = {
    createUser: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj
  };

  constructor(props) {
    super(props);
    const user = this.props.user;
    this.state = {
      user: {
        first_name: '',
        last_name: '',
        email: '',
        user_type: '',
        phone: null,
        imc: '',
        gender: '',
        registration: '',
        county: '',
        practice_name: '',
        hospital: '',
        role: '',
        title: '',
        email_confirmed: '',
        ...user
      }
    }
  }

  componentWillReceiveProps(props) {
    if (!_.isEqual(this.props.user, props.user))
      this.setState({
        user: {
          ...this.state.user,
          ...props.user,
        }
      });
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadEditUser(this.props.params.id)
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const userData = { ...this.state.user,
      ...{
        [e.target.name]: input
      }
    }

    this.setState({ user: userData });
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.props.adminUpdateUser(this.state.user)
  }

  roleFields = () => {
    switch (this.state.user.user_type) {
      case 'gp':
        return ['imc', 'practice_name']
      case 'gp_trainee':
        return ['imc', 'practice_name']
      case 'consultant':
        return ['imc', 'hospital']
      case 'hospital_doctor':
        return ['imc']
      case 'practice_nurse':
        return ['registration', 'practice_name' ]
      case 'nurse_specialist':
        return ['registration', 'imc' ]
      default: return []
    }
  }

  onFieldChange = (e) => {
    const userData = { ...this.state.user,
      ...{
        [e.target.name]: e.target.value
      }
    }

    this.setState({ user: userData })//, this.validateUser);
  }

  onCountyChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{ county: e.value }
    }
    this.setState({ user: userData });
  }

  onRoleChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{ user_type: e.target.value }
    }
    this.setState({ user: userData });
  }

  render() {
    const {
      errors,
      errorsFrontend,
    } = this.props;
    const outErrors = Object.keys(errorsFrontend || {}).length ? errorsFrontend : errors;
    return (
      <main className="site--width clearfix-c">
        <h2 className="main_title">
          User #{this.state.user.id}
        </h2>
        <ProfileForm
          user={this.state.user}
          onFieldChange={this.onFieldChange}
          onSubmit={this.onSubmit}
          errors={outErrors || {}}
          onRoleChange={this.onRoleChange}
          roleFields={this.roleFields()}
          onCountyChange={this.onCountyChange}
          is_admin={true}
        />
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  errors: state.errors[ADMIN_UPDATE_USER_SAGA],
  errorsFrontend: state.errors[`${ADMIN_UPDATE_USER_SAGA}_FRONTEND`],
  user: state.users.tmp
});


const mapDispatchToProps = (dispatch) => ({
  loadEditUser: (id) => dispatch(loadEditUser(id)),
  adminUpdateUser: (user) => dispatch(adminUpdateUserSaga(user)),
  validateUser: (errors) => dispatch(addValidateError(ADMIN_UPDATE_USER_SAGA, errors)),
  cleanErrors: () => dispatch(cleanErrors(ADMIN_UPDATE_USER_SAGA))
})

export default connect(mapStateToProps, mapDispatchToProps)(EditUser);



/** WEBPACK FOOTER **
 ** ./src/containers/Admin/User/EditUser.jsx
 **/